// ─────────────────────────────────────────────
//  writeGuard — may this quick-action actually be SAVED against this person?
//
//  Lifted out of `BenchAssignFlow` for the usual reason (that file is at the
//  500-line house limit), but it earns its own file for a better one: it is the
//  second half of a deliberate pair, and the pair is easy to break by accident.
//
//  ⚠️ `domain/assignChoices` ALREADY HIDES every id-keyed option from somebody
//  nobody identified, AND THAT IS NOT ENOUGH. A menu that offers the wrong
//  option is a copy bug; a roster / transfer / takeover write keyed to a
//  synthetic `sp:<name>` — the placeholder `secondProviderMember` mints for a
//  person the importer never matched — lands on a document nobody has ever
//  heard of, SILENTLY, because Firestore is happy to be told about an id that
//  does not exist. The operator is told it worked. `assignSecondCrna` has
//  guarded its own write since the second-provider menu shipped; Takeover,
//  Home, Give Breaks and Transfer now do the same, so the JSX staying correct
//  is not what keeps a clinician's day safe.
//
//  ⚠️ IT TAKES THE ID BEING WRITTEN, NOT THE PROVIDER. "Home" is also called for
//  the CRNA a takeover has just displaced, and that id comes off the row rather
//  than off the person whose menu is open.
//
//  ⚠️ AND THE REFUSAL IS SPOKEN. A silent return would reproduce, at the moment
//  of the write, the exact defect the identity work fixes at the moment of the
//  render: a control that does nothing and never says why.
// ─────────────────────────────────────────────
import { isResolvedProvider } from "../../domain/secondProviderWrite";

export default function writeGuard(toast) {
  return (id) => {
    if (isResolvedProvider({ id })) return true;
    toast?.error?.(
      "That name is not matched to a staff record, so this change cannot be saved against them."
    );
    return false;
  };
}
